// Auth utility for handling mobile Safari cookie issues

export const saveSessionToken = (token) => {
  localStorage.setItem('session_token', token);
};

export const getSessionToken = () => {
  return localStorage.getItem('session_token');
};

export const clearSessionToken = () => {
  localStorage.removeItem('session_token');
  localStorage.removeItem('user');
};

export const setupAxiosInterceptor = (axios) => {
  // Add session token to ALL requests from localStorage
  axios.interceptors.request.use((config) => {
    const token = getSessionToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  
  // Handle auth errors globally - redirect to login if session is invalid
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 || 
          (error.response?.status === 404 && error.response?.data?.detail === "User not found")) {
        console.error('[Auth] Session invalid, clearing token');
        clearSessionToken();
        // Don't redirect automatically - let the component handle it
        // This prevents redirect loops
      }
      return Promise.reject(error);
    }
  );
};
